import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { deleteQuestion } from "store/actions/checkoutQuestionAction";

const DeleteQuestionModal = ({ modal, confirmToggle, cancelToggle, id }) => {
  const dispatch = useDispatch();
  const { deleteLoading } = useSelector((state) => state.checkoutQuestion);

  const handleModalClick = (e) => {
    if (e.target.closest(".modal-content")) {
      return;
    }
    cancelToggle();
  };

  return (
    <Modal isOpen={modal} toggle={cancelToggle} onClick={handleModalClick}>
      <ModalHeader toggle={cancelToggle}>Delete Question</ModalHeader>
      <ModalBody>
        Deleting Questions will result in deleting responses as well, are you
        sure you want to delete the question?
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          size="sm"
          disabled={deleteLoading}
          onClick={() =>
            dispatch(
              deleteQuestion(id, () => {
                confirmToggle();
              })
            )
          }
        >
          {deleteLoading ? <Spinner size="sm" /> : "Delete"}
        </Button>{" "}
        <Button color="secondary" size="sm" onClick={cancelToggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteQuestionModal;
